import React, { useState, useEffect } from 'react';

const DollarStartClub = () => {
  const [members, setMembers] = useState(0);
  const [microEarned, setMicroEarned] = useState(0);

  useEffect(() => {
    // Animate member count
    const timer = setTimeout(() => {
      const interval = setInterval(() => {
        setMembers(prev => {
          if (prev >= 1234) {
            clearInterval(interval);
            return 1234;
          }
          return prev + 13;
        });
      }, 30);
    }, 500);

    // Animate micro earnings
    const microTimer = setInterval(() => {
      setMicroEarned(prev => prev + 0.001);
    }, 1000);

    return () => {
      clearTimeout(timer);
      clearInterval(microTimer);
    };
  }, []);

  return (
    <div className="min-h-screen bg-black text-white overflow-hidden">
      {/* Hero Section */}
      <div className="relative">
        <div className="absolute inset-0 bg-gradient-to-br from-green-900/10 via-black to-green-900/10" />

        <div className="relative max-w-6xl mx-auto px-4 py-20">
          {/* Title */}
          <div className="text-center mb-12">
            <h1 className="text-6xl md:text-8xl font-black text-green-400 mb-4">
              $1
            </h1>
            <p className="text-3xl md:text-4xl text-gray-400">
              DollarStartClub
            </p>
            <p className="text-xl text-gray-500 mt-2">
              The smallest investment that actually matters
            </p>
          </div>

          {/* Live Stats */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
            <div className="bg-gray-900 border border-green-400 rounded-lg p-6 text-center">
              <div className="text-3xl font-bold text-green-400">{members}</div>
              <div className="text-gray-400">Members Working</div>
            </div>
            <div className="bg-gray-900 border border-yellow-400 rounded-lg p-6 text-center">
              <div className="text-3xl font-bold text-yellow-400">
                ${microEarned.toFixed(3)}
              </div>
              <div className="text-gray-400">Earning Right Now</div>
            </div>
            <div className="bg-gray-900 border border-blue-400 rounded-lg p-6 text-center">
              <div className="text-3xl font-bold text-blue-400">24/7</div>
              <div className="text-gray-400">Always Earning</div>
            </div>
          </div>

          {/* The Two Paths */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            {/* Path 1: Pay $1 */}
            <div className="bg-gray-900 border-2 border-green-400 rounded-lg p-8">
              <h2 className="text-2xl font-bold text-green-400 mb-4">
                Path 1: The Dollar
              </h2>
              <div className="space-y-3 text-gray-300">
                <p>💵 Pay $1 (one time, ever)</p>
                <p>✅ Instant access to micro-tasks</p>
                <p>📈 Start earning immediately</p>
                <p>🎯 Prove you're serious</p>
              </div>
              <button className="w-full mt-6 bg-green-500 text-black px-6 py-3 rounded-lg font-bold hover:bg-green-400 transition-colors">
                Start with $1
              </button>
            </div>

            {/* Path 2: Proof of Work */}
            <div className="bg-gray-900 border-2 border-blue-400 rounded-lg p-8">
              <h2 className="text-2xl font-bold text-blue-400 mb-4">
                Path 2: Proof of Work
              </h2>
              <div className="space-y-3 text-gray-300">
                <p>💪 Complete 10 verification tasks</p>
                <p>⚡ Show you can deliver</p>
                <p>🎖️ Earn your way in</p>
                <p>💰 Keep 100% of earnings</p>
              </div>
              <button className="w-full mt-6 bg-blue-500 text-white px-6 py-3 rounded-lg font-bold hover:bg-blue-400 transition-colors">
                Prove Your Work
              </button>
            </div>
          </div>

          {/* How It Actually Works */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-lg p-8 mb-12 border border-gray-700">
            <h2 className="text-3xl font-bold text-white mb-6">
              The Micro-Economy That Works
            </h2>

            {/* Dollar Breakdown */}
            <div className="mb-8">
              <h3 className="text-xl font-bold text-yellow-400 mb-4">
                Where Your Dollar Goes:
              </h3>
              <div className="space-y-2">
                <div className="flex items-center">
                  <div className="w-32 bg-red-500 h-8 flex items-center justify-center text-black font-bold">
                    $0.35
                  </div>
                  <span className="ml-4 text-gray-400">Stripe (yeah, it hurts)</span>
                </div>
                <div className="flex items-center">
                  <div className="w-20 bg-green-500 h-8 flex items-center justify-center text-black font-bold">
                    $0.30
                  </div>
                  <span className="ml-4 text-gray-400">Task Pool (pays YOU back)</span>
                </div>
                <div className="flex items-center">
                  <div className="w-16 bg-blue-500 h-8 flex items-center justify-center text-white font-bold">
                    $0.20
                  </div>
                  <span className="ml-4 text-gray-400">Community Rewards</span>
                </div>
                <div className="flex items-center">
                  <div className="w-12 bg-purple-500 h-8 flex items-center justify-center text-white font-bold">
                    $0.15
                  </div>
                  <span className="ml-4 text-gray-400">Keep the lights on</span>
                </div>
              </div>
            </div>

            {/* Earning Mechanics */}
            <div>
              <h3 className="text-xl font-bold text-green-400 mb-4">
                How You Earn It Back (and More):
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                <div className="bg-black/50 p-3 rounded">
                  <span className="text-green-400 font-bold">$0.01</span> - Daily check-in
                </div>
                <div className="bg-black/50 p-3 rounded">
                  <span className="text-green-400 font-bold">$0.05</span> - Complete profile
                </div>
                <div className="bg-black/50 p-3 rounded">
                  <span className="text-green-400 font-bold">$0.25</span> - First task completed
                </div>
                <div className="bg-black/50 p-3 rounded">
                  <span className="text-green-400 font-bold">$0.10</span> - Refer a member
                </div>
                <div className="bg-black/50 p-3 rounded">
                  <span className="text-green-400 font-bold">$0.001</span> - Per new member (forever)
                </div>
                <div className="bg-black/50 p-3 rounded">
                  <span className="text-green-400 font-bold">$0.10</span> - Weekly streak bonus
                </div>
              </div>
            </div>
          </div>

          {/* The Philosophy */}
          <div className="bg-black border border-green-400 rounded-lg p-8 mb-12">
            <h2 className="text-3xl font-bold text-green-400 mb-4">
              Why This Actually Works
            </h2>
            <div className="space-y-4 text-lg text-gray-300">
              <p>
                <span className="text-yellow-400 font-bold">Free = No commitment.</span>
                {" "}People sign up for free stuff and ghost.
              </p>
              <p>
                <span className="text-green-400 font-bold">$1 = Just enough skin in the game.</span>
                {" "}Not a barrier, but a filter.
              </p>
              <p>
                <span className="text-blue-400 font-bold">Proof of Work = Even better filter.</span>
                {" "}Show us you can deliver, skip the dollar.
              </p>
              <p className="text-xl text-white font-bold mt-6">
                We're not building a scheme. We're building a workforce.
              </p>
            </div>
          </div>

          {/* Integration Points */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
            <div className="bg-gray-900 rounded-lg p-6 border border-gray-700 text-center">
              <div className="text-3xl mb-2">💬</div>
              <h3 className="text-xl font-bold text-white mb-2">Slack</h3>
              <p className="text-gray-400 text-sm">
                Tasks, check-ins, and payments where you already work
              </p>
            </div>
            <div className="bg-gray-900 rounded-lg p-6 border border-gray-700 text-center">
              <div className="text-3xl mb-2">📧</div>
              <h3 className="text-xl font-bold text-white mb-2">Email</h3>
              <p className="text-gray-400 text-sm">
                Daily opportunities and earning reports
              </p>
            </div>
            <div className="bg-gray-900 rounded-lg p-6 border border-gray-700 text-center">
              <div className="text-3xl mb-2">📱</div>
              <h3 className="text-xl font-bold text-white mb-2">SMS</h3>
              <p className="text-gray-400 text-sm">
                High-value task alerts (coming soon)
              </p>
            </div>
          </div>

          {/* NOT an MLM Section */}
          <div className="bg-red-900/20 border border-red-400 rounded-lg p-8 mb-12">
            <h2 className="text-2xl font-bold text-red-400 mb-4">
              ⚠️ What This is NOT
            </h2>
            <div className="space-y-2 text-gray-300">
              <p>❌ NOT an MLM - no levels, no pyramids</p>
              <p>❌ NOT a get-rich-quick scheme</p>
              <p>❌ NOT passive income bullshit</p>
              <p className="text-green-400 font-bold mt-4">
                ✅ It's micro-work for micro-pay that adds up
              </p>
            </div>
          </div>

          {/* The Math */}
          <div className="bg-gray-900 rounded-lg p-8 mb-12 border border-gray-700">
            <h2 className="text-2xl font-bold text-yellow-400 mb-4">
              The Beautiful Math
            </h2>
            <div className="font-mono text-sm space-y-2 text-gray-300">
              <p>1,000 members × $1 = $1,000</p>
              <p className="text-red-400">- $350 to Stripe (ouch)</p>
              <p className="text-green-400">= $650 in the ecosystem</p>
              <p className="mt-4">$300 → Task pool</p>
              <p>$200 → Community rewards</p>
              <p>$150 → Platform operations</p>
              <p className="mt-4 text-lg text-green-400">
                Every member can earn their dollar back + more
              </p>
            </div>
          </div>

          {/* Call to Action */}
          <div className="text-center">
            <h2 className="text-4xl font-bold text-green-400 mb-4">
              Ready to Start?
            </h2>
            <p className="text-xl text-gray-400 mb-8">
              Choose your path. Both lead to the same place.
            </p>
            <div className="flex flex-col md:flex-row gap-4 justify-center">
              <button className="bg-green-500 text-black px-8 py-4 rounded-lg font-bold text-xl hover:bg-green-400 transition-colors">
                Pay $1 & Start Now
              </button>
              <button className="bg-blue-500 text-white px-8 py-4 rounded-lg font-bold text-xl hover:bg-blue-400 transition-colors">
                Prove Your Work First
              </button>
            </div>
            <p className="text-gray-500 mt-4">
              Join {members.toLocaleString()} members already earning
            </p>
          </div>
        </div>
      </div>

      {/* Floating ticker */}
      <div className="fixed bottom-4 left-4 bg-green-500/20 backdrop-blur border border-green-400 rounded-lg px-4 py-2">
        <div className="text-green-400 font-mono text-sm">
          +${microEarned.toFixed(4)} earned while you read this
        </div>
      </div>
    </div>
  );
};

export default DollarStartClub;